import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./features/auth/authSlice";
import employeeSlice from "./features/employees/employeeSlice";
import shopsSlice from "./features/shops/shopsSlice";

export const store = configureStore({
  reducer: { auth: authSlice, shops: shopsSlice, employees: employeeSlice },
});
